export interface Product {
    Id: number | string;
    Name: string;
    Description: string;
    Price: number;
    Cost: number;
    CompanyId: number;
    Type: number;
    Active: boolean;
    ItbisId: number;
}

export interface ItbisType {
    Id: number;
    Name: string;
    Value: number;
    Type: number;
}

export interface ElectronicInvoiceProduct {
    ProductId: string;
    ProductName: string;
    Retancion?: number;
    ProductType: number;
    Price: number;
    Value: number;
    Quantity: number;
    ItbisType?: number | string;
    Itbis?: number;
    Discount: number;
    DiscountType: number; // 1 = percentage, 2 = amount
    NetValue: number;
    Total?: number;
}
export interface Retencion{
    IndicadorAgenteRetencionoPercepcion?: number;
    MontoITBISRetenido?:number;
    MontoISRRetenido?:number;
}

export const ENFCtypes = {
    31: 'Factura de Crédito Fiscal Electrónica',
    32: 'Factura de Consumo Electrónica',
    33: 'Nota de Débito Electrónica',
    34: 'Nota de Crédito Electrónica',
    41: 'Compras Electrónico',
    43: 'Gastos Menores Electrónico',
    44: 'Regímenes Especiales Electrónica',
    45: 'Gubernamental Electrónico',
    46: 'Comprobante para Exportaciones Electrónico',
    47: 'Comprobante para Pagos al Exterior Electrónico',
};

export const ModificationReason: { [key: number]: string } = {
    1: 'Anula NCF modificado',
    2: 'Corrige Texto del Comprobante Fiscal modificado',
    3: 'Corrige monto del Comprobante Fiscal modificado',
};

export type Client = {
    Id?: number;
    Name: string;
    Province: string;
    Municipality: string;
    Rnc: string;
    RncValue: string;
    clientStatus: number;
    EnfcType: number;
    Phone: string;
    Address: string;
};

export type ElectronicInvoiceDetails = {
    RNC: string;
    Name: string;
    Phone: string;
    Address: string;
    PaymentType: string;
    IncomeType: string;
    EncfType: string;
    FechaEmision: string;
    Provincia?: string;
    Municipio?: string;
    FechaLimitePago?: string;
    isWithoutRnc?: boolean;
};

export type Totals = {
    montoGravado18: number;
    montoGravado16: number;
    montoGravado0: number;
    itbis18: number;
    itbis16: number;
    itbis0: number;
    subtotalGravado: number;
    subtotalITBIS: number;
    montoExento: number;
    discount: number;
    TotalRetencion?:number;
    total: number;
};

export type ReferenceInformation = {
    DebitOrCredit: number;
    ModifiedNCF: string;
    ModificationCode: number;
    ModifiedNCFDate: string;
    CreditNoteIndicator: number;
    ExpireNCFDate: string;
};

export type BuyerInformation = {
    RNC: string;
    RncValue: string;
    Phone: string;
    Address: string;
};

export type AppliedNotes = {
    Notes?: object[];
    TotalCredito: number;
    TotalDebito: number;
};
